import "@/App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import NotFound from "@/pages/NotFound";

// Route-level code splitting keeps the first load small (better LCP / TBT on mobile).
const Pricing = lazy(() => import("@/pages/Pricing"));
const Reviews = lazy(() => import("@/pages/Reviews"));
const SampleReport = lazy(() => import("@/pages/SampleReport"));

const ServicesIndex = lazy(() => import("@/pages/Services").then((m) => ({ default: m.ServicesIndex })));
const ServiceDetail = lazy(() => import("@/pages/Services").then((m) => ({ default: m.ServiceDetail })));
const ComplianceHub = lazy(() => import("@/pages/Compliance").then((m) => ({ default: m.ComplianceHub })));
const CountryPage = lazy(() => import("@/pages/Compliance").then((m) => ({ default: m.CountryPage })));
const About = lazy(() => import("@/pages/Company").then((m) => ({ default: m.About })));
const Methodology = lazy(() => import("@/pages/Company").then((m) => ({ default: m.Methodology })));
const HowItWorks = lazy(() => import("@/pages/Company").then((m) => ({ default: m.HowItWorks })));
const Industries = lazy(() => import("@/pages/Company").then((m) => ({ default: m.Industries })));
const Partnerships = lazy(() => import("@/pages/Company").then((m) => ({ default: m.Partnerships })));
const Faq = lazy(() => import("@/pages/Company").then((m) => ({ default: m.Faq })));
const Contact = lazy(() => import("@/pages/Forms").then((m) => ({ default: m.Contact })));
const RequestAssessment = lazy(() => import("@/pages/Forms").then((m) => ({ default: m.RequestAssessment })));
const LegalPage = lazy(() => import("@/pages/Legal").then((m) => ({ default: m.LegalPage })));
const HtmlSitemap = lazy(() => import("@/pages/Legal").then((m) => ({ default: m.HtmlSitemap })));

// Reserve space while a route chunk loads so the footer does not jump (CLS).
const Fallback = () => <div className="min-h-[70vh]" aria-busy="true" />;

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Suspense fallback={<Fallback />}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<ServicesIndex />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/compliance" element={<ComplianceHub />} />
              <Route path="/compliance/:slug" element={<CountryPage />} />
              <Route path="/sample-report" element={<SampleReport />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/about" element={<About />} />
              <Route path="/methodology" element={<Methodology />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/partnerships" element={<Partnerships />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/request-assessment" element={<RequestAssessment />} />
              <Route path="/legal/:slug" element={<LegalPage />} />
              <Route path="/sitemap" element={<HtmlSitemap />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}
